<template>
	<div class="fixed inset-0 flex items-center justify-center bg-trans-gray z-20" v-show="show">
		<div class="rounded shadow bg-white w-full mx-1 sm:w-1/3">
			<div class="rounded-t bg-gray-800 px-4 py-4 text-white font-thin text-lg">
				Orders requiring approval
			</div>
			<div class="p-4">
				<div class="mr-2 mb-2" v-for="(job, index) in jobs">
					<span class="text-lg font-bold">{{ job.name }}</span>

					<div class="ml-2 mb-2 flex items-center justify-between" v-for="(order) in job.orders">
						<router-link :to="`/job/${job.id}/orders/${order.id}`" class="underline">
							{{ order.reference_id }}
						</router-link>
						<div class="flex items-center">
							<action-button class="mr-2 btn btn-blue flex items-center">
								<span>Approve</span>
							</action-button>
							<action-button class="btn btn-red flex items-center">
								<span>Deny</span>
							</action-button>
						</div>
					</div>
				</div>
			</div>
			<div class="rounded-b bg-gray-200 px-4 py-2">
				
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: ['show', 'initialJobs'],
	data () {
		return {
			priceError: [],
			jobs: this.initialJobs,
			update: {},
		}
	},
	filters:{
		toNumber: function(value){
			let val = value/100;
			return val === 0 ? null : val;
		}
	},
	methods: {},
	computed: {
		
	},
	components: {
		
	},
	watch: {
		show: {
			immediate: true,
			handler: show => {
				if (show) {
					document.body.style.setProperty('overflow', 'hidden')
				} else {
					document.body.style.removeProperty('overflow')
				}
			}
		}
	},
	created () {
		// const listener = document.addEventListener('keydown', e => {
		// 	if (this.show && e.keyCode === 27) {
		// 		this.cancel()
		// 	}
		// })

		this.$once('hook:beforeDestroy', () => {
			//document.removeEventListener('keydown', listener)
			document.body.style.removeProperty('overflow')
		});
	}
}
</script>
